"use client";

// src/avatar.tsx
import { cn } from "@momo/utils";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { jsx } from "react/jsx-runtime";
var Avatar = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    AvatarPrimitive.Root,
    {
      className: cn("relative flex size-10 shrink-0 overflow-hidden rounded-full", className),
      ...rest
    }
  );
};
var AvatarImage = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(AvatarPrimitive.Image, { className: cn("aspect-square size-full", className), ...rest });
};
var AvatarFallback = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    AvatarPrimitive.Fallback,
    {
      className: cn("bg-muted flex size-full items-center justify-center rounded-full", className),
      ...rest
    }
  );
};

export {
  Avatar,
  AvatarImage,
  AvatarFallback
};
